import type { AppLanguage } from '../i18n/types';
import {
  TIME_HOURS_24,
  formatRoundHourTimeLabel,
  hourFromTimeHm,
  normalizeHourOptionList,
} from '../utils/timeLocale';
import styles from './RoundHourTimeInput.module.css';

type RoundHourTimeInputProps = {
  id: string;
  value: string;
  onChange: (next: string) => void;
  /** @deprecated Kept for call-site compatibility; labels are always `HH:00`. */
  language?: AppLanguage;
  /** When set, only these whole hours are selectable (`HH` or `HH:00`). */
  hours?: readonly string[];
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
};

/** Whole-hour picker (`HH:00` wire value; UI shows hours only). */
export function RoundHourTimeInput({
  id,
  value,
  onChange,
  hours,
  disabled = false,
  className,
  ariaLabel,
}: RoundHourTimeInputProps) {
  const options = normalizeHourOptionList(hours === undefined ? TIME_HOURS_24 : hours);
  const selectedHour = options.includes(hourFromTimeHm(value))
    ? hourFromTimeHm(value)
    : (options[0] ?? '09');
  const selectClass = [styles.select, className].filter(Boolean).join(' ');

  return (
    <select
      id={id}
      className={selectClass}
      value={selectedHour}
      disabled={disabled || options.length === 0}
      aria-label={ariaLabel}
      onChange={(event) => onChange(`${event.target.value}:00`)}
    >
      {options.map((h) => (
        <option key={h} value={h}>
          {formatRoundHourTimeLabel(h)}
        </option>
      ))}
    </select>
  );
}
